module.exports = __webpack_public_path__ + "img/ask_bg.eda2dfb7.png";